import { articleSigneringMedMitid } from './articles/signeringMedMitid';
import { articleSomeSignaturesAreInvalid } from './articles/someSignaturesAreInvalid';
import { articleAtLeastOneSignatureIsInvalid } from './articles/atLeastOneSignatureIsInvalid';
import { articleMitIdVsErhverv } from './articles/mitidVsErhverv';
import { articleOkKnapTouchEid } from './articles/okKnapTouchEid';
import { articleBilligDigitalUnderskrift } from './articles/billigDigitalUnderskrift';
import { articleElektroniskUnderskriftDanmark } from './articles/elektroniskUnderskriftDanmark';
import { articleDigitalUnderskriftGuide } from './articles/digitalUnderskriftGuide';
import { articleJuridiskBindendeSignatur } from './articles/juridiskBindendeSignatur';
import { articleKviksignVsDocusign } from './articles/kviksignVsDocusign';
import { articleKviksignVsAddoSign } from './articles/kviksignVsAddoSign';
import { articleSendDokumenterSikkert } from './articles/sendDokumenterSikkert';
import { articleTop10Signering2026 } from './articles/top10Signering2026';
import { articleQesGyldighedEu } from './articles/qesGyldighedEu';
import { articleDigitalSignaturErhvervGuide } from './articles/digitalSignaturErhvervGuide';
import { articleUnderskrivPdfDokumentMedMitid } from './articles/underskrivPdfDokumentMedMitid';
import { articleBedsteDigitaleUnderskriftloesningerMindreVirksomheder } from './articles/bedsteDigitaleUnderskriftloesningerMindreVirksomheder';
import { articleNemidDigitalSignaturUdfasningMitid } from './articles/nemidDigitalSignaturUdfasningMitid';
import { articleDatalaekCprNumreDanmark } from './articles/datalaekCprNumreDanmark';
import { articleTalerDuMedDenRetteIdentitetsverifikation } from './articles/talerDuMedDenRetteIdentitetsverifikation';
import { articleBorgerguideSikkerIdentitetsbekraeftelseKvikid } from './articles/borgerguideSikkerIdentitetsbekraeftelseKvikid';
import { articleVirksomhedsguideForebygTelefonsvindelKvikid } from './articles/virksomhedsguideForebygTelefonsvindelKvikid';
import { articleEjerfuldmagtNetselskabSolceller } from './articles/ejerfuldmagtNetselskabSolceller';
import { articleDigitalAnsaettelseskontraktMitid } from './articles/digitalAnsaettelseskontraktMitid';
import { articleFortrolighedsaftaleNdaSkabelon } from './articles/fortrolighedsaftaleNdaSkabelon';
import { articleUnderskriftBestyrelsesreferat } from './articles/underskriftBestyrelsesreferat';
import { articleHaandvaerkerkontraktAb18 } from './articles/haandvaerkerkontraktAb18';
import { articleGaeldsbrevLaaneaftaleMitid } from './articles/gaeldsbrevLaaneaftaleMitid';
import { articleSamtykkeerklaeringGdprSignatur } from './articles/samtykkeerklaeringGdprSignatur';
import { articleErhvervslejekontraktFremleje } from './articles/erhvervslejekontraktFremleje';
import { articleKonsulentaftaleFreelancekontrakt } from './articles/konsulentaftaleFreelancekontrakt';
import { articleKviksignVsPenneoScriveVismaSign } from './articles/kviksignVsPenneoScriveVismaSign';
import { articleKviksignVsAdobeSign } from './articles/kviksignVsAdobeSign';
import { articleKviksignVsSignaturgruppen } from './articles/kviksignVsSignaturgruppen';
import { articleKviksignVsDropboxSign } from './articles/kviksignVsDropboxSign';
import { articleKviksignVsYousign } from './articles/kviksignVsYousign';
import { articleKviksignVsPandadoc } from './articles/kviksignVsPandadoc';
import { articleKviksignVsEBoks } from './articles/kviksignVsEBoks';
import { articleDigitalUnderskriftKoebsaftale } from './articles/digitalUnderskriftKoebsaftale';
import { articleDigitalFuldmagtMitid } from './articles/digitalFuldmagtMitid';
import { articleOpsigelseLejemaalDigitalSignatur } from './articles/opsigelseLejemaalDigitalSignatur';
import { articleDigitalSignaturRevisorBogholder } from './articles/digitalSignaturRevisorBogholder';

export interface ArticleFAQ {
  question: string;
  answer: string;
}

export interface ArticleSource {
  title: string;
  url: string;
}

export interface ArticleSection {
  id: string;
  title: string;
  paragraphs: string[];
  subsections?: {
    title: string;
    paragraphs: string[];
    listItems?: string[];
  }[];
  listItems?: string[];
  proTip?: string;
  callout?: {
    type: 'info' | 'tip' | 'warning';
    title?: string;
    text: string;
  };
  authorQuote?: {
    text?: string;
    author: string;
  };
  image?: {
    url?: string;
    alt?: string;
    caption?: string;
    isPlatformScreenshot?: boolean;
  };
  secondaryImage?: {
    url: string;
    alt: string;
    caption?: string;
  };
}

export interface Article {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  description?: string;
  metaTitle: string;
  metaDescription: string;
  canonicalUrl: string;
  heroImage: string;
  heroImageAlt: string;
  category: string;
  author: {
    name: string;
    role: string;
    avatar: string;
  };
  publishedAt: string;
  updatedAt: string;
  readingTime: string;
  readTime?: string;
  primaryKeyword?: string;
  secondaryKeywords?: string[];
  keywords: string[];
  keyTakeaways: string[];
  tableOfContents: {
    id: string;
    title: string;
  }[];
  sections: ArticleSection[];
  faqs: ArticleFAQ[];
  sources: ArticleSource[];
  disclaimer: string;
  backlinkCredit?: {
    text: string;
    linkText: string;
    url: string;
  };
}

export type ArticleItem = Article;

import { ENGLISH_ARTICLES } from './articlesEnglishData';
import { SWEDISH_ARTICLES } from './articlesSwedishData';

export const formatDanishDate = (dateStr: string, lang: 'da' | 'en' | 'sv' = 'da'): string => {
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const year = parts[0];
  const monthIdx = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);
  
  if (lang === 'en') {
    const monthsEn = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${monthsEn[monthIdx]} ${day}, ${year}`;
  }

  if (lang === 'sv') {
    const monthsSv = [
      'januari', 'februari', 'mars', 'april', 'maj', 'juni',
      'juli', 'augusti', 'september', 'oktober', 'november', 'december'
    ];
    return `${day} ${monthsSv[monthIdx]} ${year}`;
  }

  const months = [
    'januar', 'februar', 'marts', 'april', 'maj', 'juni',
    'juli', 'august', 'september', 'oktober', 'november', 'december'
  ];
  return `${day}. ${months[monthIdx]} ${year}`;
};

export const getLocalizedArticle = (article: Article, lang: 'da' | 'en' | 'sv' = 'da'): Article => {
  if (lang === 'en' && ENGLISH_ARTICLES[article.slug]) {
    const enData = ENGLISH_ARTICLES[article.slug];
    return {
      ...article,
      ...enData,
      author: {
        ...article.author,
        role: article.author.role === 'Stifter & Sikkerhedsansvarlig' ? 'Founder & Head of Security' : (enData.author?.role || article.author.role)
      },
      sections: enData.sections || article.sections,
      faqs: enData.faqs || article.faqs,
      keyTakeaways: enData.keyTakeaways || article.keyTakeaways,
      tableOfContents: enData.tableOfContents || article.tableOfContents
    } as Article;
  }

  if (lang === 'sv' && SWEDISH_ARTICLES[article.slug]) {
    const svData = SWEDISH_ARTICLES[article.slug];
    return {
      ...article,
      ...svData,
      author: {
        ...article.author,
        role: article.author.role === 'Stifter & Sikkerhedsansvarlig' ? 'Grundare & Säkerhetsansvarig' : (svData.author?.role || article.author.role)
      },
      sections: svData.sections || article.sections,
      faqs: svData.faqs || article.faqs,
      keyTakeaways: svData.keyTakeaways || article.keyTakeaways,
      tableOfContents: svData.tableOfContents || article.tableOfContents
    } as Article;
  }

  return article;
};

export const ARTICLES_DATA: Article[] = [
  articleKviksignVsAdobeSign,
  articleKviksignVsSignaturgruppen,
  articleKviksignVsDropboxSign,
  articleKviksignVsYousign,
  articleKviksignVsPandadoc,
  articleKviksignVsEBoks,
  articleDigitalUnderskriftKoebsaftale,
  articleDigitalFuldmagtMitid,
  articleOpsigelseLejemaalDigitalSignatur,
  articleDigitalSignaturRevisorBogholder,
  articleEjerfuldmagtNetselskabSolceller,
  articleDigitalAnsaettelseskontraktMitid,
  articleFortrolighedsaftaleNdaSkabelon,
  articleUnderskriftBestyrelsesreferat,
  articleHaandvaerkerkontraktAb18,
  articleGaeldsbrevLaaneaftaleMitid,
  articleSamtykkeerklaeringGdprSignatur,
  articleErhvervslejekontraktFremleje,
  articleKonsulentaftaleFreelancekontrakt,
  articleKviksignVsPenneoScriveVismaSign,
  articleBorgerguideSikkerIdentitetsbekraeftelseKvikid,
  articleVirksomhedsguideForebygTelefonsvindelKvikid,
  articleDatalaekCprNumreDanmark,
  articleTalerDuMedDenRetteIdentitetsverifikation,
  articleDigitalSignaturErhvervGuide,
  articleUnderskrivPdfDokumentMedMitid,
  articleBedsteDigitaleUnderskriftloesningerMindreVirksomheder,
  articleNemidDigitalSignaturUdfasningMitid,
  articleAtLeastOneSignatureIsInvalid,
  articleSigneringMedMitid,
  articleQesGyldighedEu,
  articleTop10Signering2026,
  articleSendDokumenterSikkert,
  articleKviksignVsAddoSign,
  articleKviksignVsDocusign,
  articleJuridiskBindendeSignatur,
  articleDigitalUnderskriftGuide,
  articleElektroniskUnderskriftDanmark,
  articleBilligDigitalUnderskrift,
  articleOkKnapTouchEid,
  articleSomeSignaturesAreInvalid,
  articleMitIdVsErhverv
];

export const getArticleBySlug = (slug: string, lang: 'da' | 'en' | 'sv' = 'da'): Article | undefined => {
  const found = ARTICLES_DATA.find((a) => a.slug === slug || a.id === slug);
  if (!found) return undefined;
  return getLocalizedArticle(found, lang);
};
